import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AuthState } from '../../state/auth.state';
import { AuthService } from '../../auth/auth.service';
import { HasRole } from '../../auth/has-role.directive';
import { runtimeEnvironmentLabel } from '../../config/runtime-config';
import { administrationEnabled } from '../../config/feature-flags';

@Component({
  selector: 'app-header',
  imports: [
    NgOptimizedImage,
    RouterLink,
    RouterLinkActive,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    HasRole,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  protected readonly authState = inject(AuthState);
  private readonly authService = inject(AuthService);

  protected readonly environmentLabel = runtimeEnvironmentLabel();
  protected readonly administrationEnabled = administrationEnabled();

  protected logout(): void {
    this.authService.logout();
  }
}
